import React from 'react';

const DraggableSymbols = ({ onDragStart, disabled = false }) => {
  // Define the available musical symbols
  const symbols = [
    { id: 'whole_note', label: '𝅝', name: 'Whole Note' },
    { id: 'half_note', label: '𝅗𝅥', name: 'Half Note'},
    { id: 'quarter_note', label: '♩', name: 'Quarter Note' },
    { id: 'eighth_note', label: '♪', name: 'Eighth Note' },
    // { id: 'double-eighth-note', label: '♫', name: 'Whole Note' },
    // { id: 'sharp', label: '♯', name: 'Sharp' },
    // { id: 'flat', label: '♭', name: 'Flat' },
    // { id: 'natural', label: '♮', name: 'Natural' },
    // { id: 'rest', label: '𝄽', name: 'Rest' }
  ];
  
  // Handle drag start event with increased symbol size during dragging
  const handleDragStart = (e, symbol) => {
    // Prevent dragging if disabled
    if (disabled) {
      e.preventDefault();
      return;
    }
    
    // Create a custom drag image with larger size
    const dragIcon = document.createElement('div');
    dragIcon.style.fontSize = '50px';
    dragIcon.style.width = '50px';
    dragIcon.style.height = '50px';
    dragIcon.style.display = 'flex';
    dragIcon.style.alignItems = 'center';
    dragIcon.style.justifyContent = 'center';
    dragIcon.style.position = 'absolute';
    dragIcon.style.top = '-1000px';
    dragIcon.style.opacity = '0.8';
    dragIcon.textContent = symbol.label;
    
    // Add the drag icon to the document
    document.body.appendChild(dragIcon);
    
    // Set the custom drag image
    e.dataTransfer.setDragImage(dragIcon, 25, 25);
    
    // Set the data for the drop target
    e.dataTransfer.setData('application/json', JSON.stringify(symbol));
    
    // Remove the drag icon after a short delay
    setTimeout(() => {
      if (document.body.contains(dragIcon)) {
        document.body.removeChild(dragIcon);
      }
    }, 0);
    
    // Trigger global drag start event for the staff component
    const dragStartEvent = new Event('dragstart', { bubbles: true });
    document.dispatchEvent(dragStartEvent);
    
    if (onDragStart) {
      onDragStart(symbol);
    }
  };

  // Handle drag end event
  const handleDragEnd = (e) => {
    // Trigger global drag end event for the staff component
    const dragEndEvent = new Event('dragend', { bubbles: true });
    document.dispatchEvent(dragEndEvent);
  };
  
  return (
    <div className="draggable-symbols-container" style={{
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      border: '1px solid #e9ecef'
    }}>
      <h3 style={{
        margin: '0 0 15px 0',
        fontSize: '18px',
        color: '#495057',
        textAlign: 'center'
      }}>
        Musical Symbols
      </h3>
      <div className="draggable-symbols" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '15px',
        justifyContent: 'center'
      }}>
        {symbols.map(symbol => (
          <div 
            key={symbol.id}
            className="draggable-symbol" 
            draggable={!disabled} 
            data-symbol={symbol.id}
            title={symbol.name}
            style={{ 
              fontSize: '40px', 
              width: '60px', 
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: disabled ? '#f8f9fa' : '#ffffff',
              border: disabled ? '2px solid #e9ecef' : '2px solid #dee2e6',
              borderRadius: '8px',
              cursor: disabled ? 'not-allowed' : 'grab',
              transition: 'all 0.2s ease',
              boxShadow: disabled ? 'none' : '0 2px 4px rgba(0,0,0,0.1)',
              userSelect: 'none',
              opacity: disabled ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!disabled) {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }
            }}
            onMouseLeave={(e) => {
              if (!disabled) {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              }
            }}
            onDragStart={(e) => {
              if (!disabled) {
                e.target.style.opacity = '0.5';
                e.target.style.transform = 'scale(0.9)';
              }
              handleDragStart(e, symbol);
            }}
            onDragEnd={(e) => {
              if (!disabled) {
                e.target.style.opacity = '1';
                e.target.style.transform = 'scale(1)';
              }
              handleDragEnd(e);
            }}
          >
            {symbol.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DraggableSymbols;